'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getSignInHref = function getSignInHref(redirectUrl) {
  var query = redirectUrl ? '?redirectUrl=' + encodeURIComponent(redirectUrl) : '';
  return '/sign-in' + query;
};

exports.default = getSignInHref;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/getSignInHref.js
// module id = 291
// module chunks = 11